
import axios from 'axios'
// let baseURL
// let baseURL = "/api";
// // let baseURL = "/";
// if (process.env.NODE_ENV === 'production') {
//   baseURL = 'http://192.168.0.248:12999';//测试环境
//   // baseURL = 'http://192.168.1.169:8081';//线上的ip地址
// }else{
//   baseURL = 'http://192.168.0.248:12999';
// }
let url=window.location.host.split(':')[0]
// console.log(window.location.host,'window.location.host')
// console.log(url,'url')
let baseURL = '';
switch (process.env.VUE_APP_ENV) {
  case 'development':
    baseURL = process.env.VUE_APP_API_DEV;
    break;
  case 'test':
    baseURL = process.env.VUE_APP_API_TEST;
    break;
  case 'production':
    // 
    // baseURL = process.env.VUE_APP_API_PROD;
    baseURL = `http://${url}:9000`;
    break;
  default:
    baseURL = '/api';
}
const request = axios.create({
  // 此处的 '/api' 和 vite.config.js 的配置相关联
  baseURL,
  timeout: 50000,
  headers: {
    //请求为异步设置
    // "x-requested-with": "XMLHttpRequest",
    //请求类容数据格式
    // "Content-Type": "application/x-www-form-urlencoded",
    "Content-type":'application/json;charset=UTF-8',
  },
});

// 数据请求拦截
request.interceptors.request.use((config) => {

  // 1. 返回config对象
  // 2. 可以设置携带 token 信息
  // console.log(config,'config');
  return config;
});


// 返回响应数据拦截
request.interceptors.response.use((response) => {
  // console.log("request.js打印返回信息" , response);
  // 简化返回数据
    return response.data;
}, 
// 错误执行
(error) => {
  console.log("错误信息", error);
  
  return Promise.reject(new Error(error.message));
});

// 暴露对象
export default request

